export default "__VITE_ASSET__sffC8Y0n__";